const initialFileDataState = {
  files : false,
  lastAdded : false,
  hasBeenEdited: false,
  upload_in_progress: false,
  files_in_progress : {}
}

export const FileReducer = (state = initialFileDataState, action = {}) => {

    switch (action.type) {
        case 'SET_ALL_FILES':
          return {
            ...state,
            files: action.files,
            columns: action.columns
          }
        case 'SET_LAST_FILE':
            return {
                ...state,
                lastAdded: action.payload
            }
        case 'REMOVE_LAST_FILE_ID':
            return {
                ...state,
                lastAdded: false
            }
        case 'FILE_HAS_BEEN_EDITED':
            return {
              ...state,
              hasBeenEdited: action.status
            }
        case 'FILE_IN_PROGRESS':

            return {
                ...state,
                files_in_progress : {
                    ...state.files_in_progress,
                    [action.payload.unique] : {
                        filename : action.payload.filename,
                        progress: action.payload.progress,
                        message: action.payload.message
                    }
                }
            }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/FileReducer.js